import { TableState } from 'src/types/redux';
import {
  FETCH_TABLE_FAILURE,
  FETCH_TABLE_REQUEST,
  FETCH_TABLE_SUCCESS,
  TableActionType,
} from '../types/tableType';

const initialState: TableState = {
  error: '',
  loading: false,
  tableData: [],
};

export const tableReducer = (
  state = initialState,
  action: TableActionType
): TableState => {
  switch (action?.type) {
    case FETCH_TABLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        tableData: action?.payload,
      };
    case FETCH_TABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
